'use client';

import { Button } from '~/components/primitives';
import Title from '~/components/utils/Title';
import { next } from '~/modules';
import { recoverFromChunkLoadError } from '~/utils/chunk-load-recovery';
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

export default function __Error(props: next.ErrorProps) {
    useEffect(() => {
        console.error('error.tsx:', props.error);
        Sentry.captureException(props.error);

        /* After the capture, so the event is on its way out before the page is replaced. */
        recoverFromChunkLoadError(props.error);
    }, [props.error]);

    return (
        <div className="container flex h-[600px] items-center">
            <div className="flex w-1/2 flex-col rounded-4xl bg-white p-10">
                <span className="mb-2 block text-4xl font-extrabold text-secondary">Oops!</span>
                <Title size="6xl" className="mb-6">
                    Something went wrong!
                </Title>

                <p>
                    <strong>Error message</strong>
                </p>
                <pre className="max-w-full overflow-x-scroll">{props.error.message}</pre>

                <Button onClick={props.reset} className="mt-6 mr-auto">
                    Reload page
                </Button>
            </div>
        </div>
    );
}
